module.exports = __webpack_public_path__ + "img/Otros servicios-panel.ca163654.svg";